export default {
    // 首页（高频，添加 prefetch 让构建工具在浏览器空闲时自动预加载）
    adminIndex: () => import(/* webpackPrefetch: true */ '@/views/admin/home/overview.vue'),

    // 账号管理
    //account: null,
    // 账号管理-账号信息
    accountInfo: () => import('@/views/admin/account/info.vue'),
    // 消息中心（通知中心页，隐藏路由：由 HeaderBar 铃铛入口进入）
    messageCenter: () => import('@/views/admin/message/index.vue'),
    // 我的任务（生产工单派工行视角，菜单 url=myTask、path=/admin/myTask/index，后端下发）
    myTask: () => import('@/views/admin/myTask/index.vue'),
    // 审批中心（待我审批 / 我已审批 / 我发起的，隐藏路由：由 HeaderBar「待我审批」入口进入）
    approvalCenter: () => import('@/views/admin/approval/index.vue'),
    // 审批中心（左侧菜单路径 /workflow，挂 1067「应用管理」下）：
    // 2026-10-02 起原「工作流」菜单更名「审批中心」，仅审批实例三 Tab；
    // 菜单来自后端 chs_function_info 1439「审批中心」（url=workflow，需 chs_business_function + chs_role_ms_authority 授权）
    workflow: () => import('@/views/admin/approval/index.vue'),
    // 流程定义（与「审批中心」并列的独立菜单，左侧菜单路径 /wfDef，挂 1067「应用管理」下）：
    // 组件即原审批中心第 4 个 Tab 的 WfDefList 独立面板；
    // 菜单来自后端 chs_function_info 1460「流程定义」（url=wfDef）
    wfDef: () => import('@/views/admin/approval/def.vue'),
    // 账号管理-角色管理
    accountRole: () => import('@/views/admin/account/role.vue'),
    // 账号管理-账号管理
    accountUser: () => import('@/views/admin/account/user.vue'),
    // 账号管理-部门管理
    accountDepartment: () => import('@/views/admin/account/department.vue'),

    // 订单（高频，添加 prefetch）
    //order: null,
    // 订单-订单管理
    orderList: () => import(/* webpackPrefetch: true */ '@/views/admin/order/list.vue'),
    // 订单-订单详情
    orderDetail: () => import('@/views/admin/order/detail.vue'),
    // 产品列表（高频，添加 prefetch）
    productList: () => import(/* webpackPrefetch: true */ '@/views/admin/product/list.vue'),
    // 产品发布
    productPublish: () => import('@/views/admin/product/publish.vue'),

    // 商家
    businessIndex: () => import('@/views/admin/business/businessIndex.vue'),
    businessVenuesList: () => import('@/views/admin/business/venue/index.vue'),
    businessVenueDetail: () => import('@/views/admin/business/venue/detail.vue'),
    businessInfoBasic: () => import('@/views/admin/business/info/basic.vue'),
    businessInfoSubject: () => import('@/views/admin/business/info/subject.vue'),
    businessBrandIndex: () => import('@/views/admin/business/brand/index.vue'),
    businessPlatformList: () => import('@/views/admin/business/platform/list.vue'),
    // 续费管理（左侧菜单路径 /admin/renewal/index，挂 1067「应用管理」下，与「应用列表」同级）：
    // 一行 = 一条订阅 = (businessId, shopStockId)；数据源 /chsRenewal/getBusinessRenewalList.json
    // （赋权见 xqyy_dao/src/main/resources/sql/saas_renewal_management_permission.sql）
    renewalCenter: () => import('@/views/admin/business/renewal/index.vue'),
    businessCertList: () => import('@/views/admin/business/platform/cert.vue'),
    businessLogList: () => import('@/views/admin/business/log/list.vue'),
    businessOnlineUserList: () => import('@/views/admin/business/onlineUser/list.vue'),
    dynamicTable: () => import('@/views/admin/business/dynamicTable/list.vue'),

    // 用户-用户管理
    userList: () => import('@/views/admin/user/list.vue'),
    // 用户-会员管理
    memberList: () => import('@/views/admin/member/memberList.vue'),

    // 营销活动
    marketingActivityList: () => import('@/views/admin/marketing/activityList.vue'),
    marketingActivityEdit: () => import('@/views/admin/marketing/activityEdit.vue'),

    // 会员等级
    memberLevelList: () => import('@/views/admin/member/levelList.vue'),

    // 代销商管理
    franchiserList: () => import('@/views/admin/franchiser/index.vue'),

    // 空间管理
    fileSpaceList: () => import('@/views/admin/fileSpace/index.vue'),

    // 库存/物料管理
    inventoryProduct: () => import('@/views/admin/inventory/product.vue'),
    // 物料类型管理
    inventoryProductType: () => import('@/views/admin/inventory/productType.vue'),
    inventoryList: () => import('@/views/admin/inventory/list.vue'),
    labelTemplate: () => import('@/views/admin/inventory/labelTemplate.vue'),
    inventoryInbound: () => import('@/views/admin/inventory/inbound.vue'),
    inventoryOutbound: () => import('@/views/admin/inventory/outbound.vue'),
    deliveryOrder: () => import('@/views/admin/inventory/deliveryOrderSend.vue'),
    deliveryOrderSend: () => import('@/views/admin/inventory/deliveryOrderSend.vue'),
    deliveryOrderReceive: () => import('@/views/admin/inventory/deliveryOrderReceive.vue'),
    // 退货返修单（左侧菜单 path=/returnRepairOrder，菜单 url 即组件键，须与后端 chs_function_info 配置一致）
    returnRepairOrder: () => import('@/views/admin/inventory/returnRepair/index.vue'),

    // BOM 管理
    bomList: () => import('@/views/admin/bom/list.vue'),
    // 物料替代组
    imsSubstituteGroup: () => import('@/views/admin/bom/substituteGroup.vue'),

    // 客户/供应商管理
    customerList: () => import('@/views/admin/customer/index.vue'),
    supplierList: () => import('@/views/admin/supplier/index.vue'),

    // 客户结算单管理
    customerSettlementBillList: () => import('@/views/admin/customerSettlement/index.vue'),

    // 供应商结算单管理
    supplierSettlementBillList: () => import('@/views/admin/supplierSettlement/index.vue'),

    // 采购/销售订单管理
    purchaseOrderList: () => import('@/views/admin/purchase/index.vue'),
    salesOrderList: () => import('@/views/admin/sales/index.vue'),

    // 工单管理
    produceOrderList: () => import('@/views/admin/produceOrder/list.vue'),
    // 领料/退料单（左侧菜单 path=/workOrderIssueDoc，菜单来自后端 chs_function_info 1443，
    // 组件键必须与菜单 url（workOrderIssueDoc）完全一致，否则 buildAdminRoutes 不设 component、菜单点开是空路由）
    workOrderIssueDoc: () => import('@/views/admin/produceOrder/issueDoc/index.vue'),
    produceOrderStandardRouting: () => import('@/views/admin/produceOrder/standardRouting.vue'),
    // 工单模板设置**不在商家端**（2026-10-07 移除）：模板设置项与扩展字段统一由总后台
    // `ui/xqyy-ms-ui`（`businessProduceOrderTemplate.vue` / `/ms/szImsOrderTemplate*`）配置，
    // 商家端只在工单页/标签模板页**只读消费**模板。此处不得再注册 `produceOrderTemplate` 组件键
    // （商家端 `chs_function_info` 中本就没有 type=1 且 url=produceOrderTemplate 的菜单）。
    dispatchTemplateList: () => import('@/views/admin/dispatchTemplate/list.vue'),

    // 计件工资
    pieceWageDailySummary: () => import('@/views/admin/pieceWage/dailySummary.vue'),
    pieceWageAdjustment: () => import('@/views/admin/pieceWage/adjustment.vue'),
    pieceWageDispute: () => import('@/views/admin/pieceWage/dispute.vue'),
    pieceWageMonthlySalary: () => import('@/views/admin/pieceWage/monthlySalary.vue'),

    // 工资模板 / 考勤 / 请假
    salaryTemplateList: () => import('@/views/admin/salaryTemplate/list.vue'),
    workerAttendanceList: () => import('@/views/admin/workerAttendance/list.vue'),
    workerLeaveList: () => import('@/views/admin/workerLeave/list.vue')
};
